module.exports = __webpack_public_path__ + "img/references_delfi2017.d8a37e63.gif";